<template>
  <div class="ma-2 ml-3 site_content">
    <comboFarm
        @fromFarm="farmInfo"
      />

    <div class="value_container">
      <div>
        <v-sheet class="timebar ml-2"
        >
          <v-slider 
            :loading="loading" 
            label="간격"
            color="#005B96"
            track-color="gray"
            v-model="term"
            :tick-labels="['15분', '1시간', '일별', '월별']"
            :max="3"
            step="1"
            ticks="always"
            tick-size="3"
            @change="refreshData()"
          ></v-slider>
        </v-sheet>
      </div>

      <div class="flex vertical-center mb-col">
        <div class="mb-flex flex vertical-center">
          <v-btn
            :disabled = "showList"
            class="ma-2 show__btn"
            @click="showList = true; refreshData()"
          >
            목록
            <v-icon right >mdi-view-list</v-icon>
          </v-btn>
          <v-btn
            :disabled = "!showList"
            class="ma-2 show__btn"
            @click="showList = false; refreshData()"
          >
            차트
            <v-icon right dark>mdi-chart-line</v-icon>
        </v-btn>
        </div>
        <div class="flex mb-picker">
          <datePicker
            :fr_date="fr_date" 
            :to_date="to_date" 
            :term="term"
            @update:fr_date="updateFrDate"
            @update:to_date="updateToDate"
            @refresh="refreshData"
          />
        </div>
      </div>
    </div>

    <div class="watt-conatiner">
      <v-tabs color="#005B96" v-model="tab" class="cost-tabs">
        <v-tab v-for="(watt, k) in kepco" :key="k" class="cost-tab">
          <span class="kepco-text"> 
            <span class="info-text">한전고객번호</span><br/>
            {{ watt.kepco_no }} </span>
        </v-tab>
      </v-tabs>
      <v-tabs-items v-model="tab" class="tab-container">
        <v-tab-item   v-for="(watt, k) in kepco" :key="k">
          <div v-show="!showList">
            <div v-if="term !== undefined && term < 2">
              <Chart
              :services="{}"
              chartTypeY1="Bar" 
              chartTypeY2="Line" 
              :y1DefaultValue="'watt'"
              :y2DefaultValue="'temp'"
              :buttonsY1="buttonsY1"
              :buttonsY2="buttonsY2"
              :trendData="getTrendDataForKepco(watt.kepco_no)"
              :chartOptions="CompareBarOption"
              :chartSize="chartSize"
              />
            </div>

            <div v-else-if="term !== undefined && term === 2">
              <div
                v-for="(data, i) in trendDataKeys" :key="i"
                v-show="getTrendDataForKepco(watt.kepco_no)"
                class="chart_layout">
                
                <div>
                  <span class="label">{{ data.label }}</span>
                </div>

                <div>
                  <DailyChart
                  chartType="Line"
                  :chart-data="getChartData(data, watt.kepco_no)"
                  :chartOptions="lineBarOptions"
                  :chartSize="dailySize"
                  />
                </div>
               
              </div>
            </div>

            <div v-else>
              <div
                v-for="(data, i) in trendDataKeys" :key="i"
                v-show="getTrendDataForKepco(watt.kepco_no)"
                class="chart_layout">
                
                <div>
                  <span class="label">{{ data.label }}</span>
                </div>

                <div>
                  <DailyChart
                  chartType="Line"
                  :chart-data="getChartData(data, watt.kepco_no)"
                  :chartOptions="lineBarOptions"
                  :chartSize="dailySize"
                  />
                </div>
              </div>
            </div>
          </div>


          <div v-show="showList">
            <div v-if="term !== undefined && term < 2">
              <Table 
                :items="getListDataForKepco(watt.kepco_no)"
                :headers = "headers"
                :loadingTable = "loading"
                :divisionTerm= "term"
              />
            </div>

            <div v-else-if="term !== undefined && term === 2">
              <DailyTable
                :listData_daily="getListDataForKepco(watt.kepco_no)"
                :dailyHeader="dailyheaders"
                :loadingTable = "loading"
                />
            </div>

            <div v-else>
               <DailyTable
                :listData_daily="getListDataForKepco(watt.kepco_no)"
                :dailyHeader="dailyheaders"
                :loadingTable = "loading"
                />
            </div>
          </div>

        </v-tab-item>
      </v-tabs-items>

    
    </div>
  </div>
</template>

<script>
import Apis from '@/api/apis'
import dateUtil from "@/utils/custom/dateProperty.js";

import datePicker from "@/components/compo/datePicker_day.vue";
import comboFarm from "@/components/combo/farm.vue";
import Chart from '@/components/chart/CompareChart.vue';
import DailyChart from '@/components/chart/Chart.vue';
import Table from '@/components/compo/Table.vue';
import DailyTable from '@/components/compo/dailyTable.vue';

import { CompareBarOption,lineBarOptions } from "@/components/chart/option.js"; 



export default {
  name: 'Summary',
  components:{
    comboFarm,
    datePicker,
    Chart,
    DailyChart,
    Table,
    DailyTable
  },
  data() {
    return {
      CompareBarOption:CompareBarOption,
      lineBarOptions:lineBarOptions,

      tab:null,

      farmData: { company: {}, farm: {} },
      showList: false,

      fr_date: "",
      to_date: "",

      term:1,
      loading:false,

      chartSize: {
        height:'100%',
        width: '100%',
      },
      dailySize:{
        height:'20vh',
        width:'100%'
      },

      y1Value: 'watt',
      y2Value: 'temp',

      buttonsY1: [
        { value: 'watt', title: '전력량', icon: require('@/assets/monitoring/icon/lightning-bolt.svg'), activeClass: 'watt_active' },

      ],
      buttonsY2: [
        { value: 'temp', title: '온도', icon: require('@/assets/monitoring/icon/temp.svg'), activeClass: 'temp_active' },
        { value: 'hum', title: '습도', icon: require('@/assets/monitoring/icon/humidity.svg'), activeClass: 'hum_active' },
        { value: 'pres', title: '기압', icon: require('@/assets/monitoring/icon/pressure.svg'), activeClass: 'pres_active' },
        { value: 'wind', title: '풍속', icon: require('@/assets/monitoring/icon/windy.svg'), activeClass: 'wind_active' },
      ],

      trendDataKeys: [
        { type: "temp", label: "온도", color: "#8CC0DE" },
        { type: "hum", label: "습도", color: "#CCEEBC" },
        { type: "pres", label: "기압", color: "#a8d9f6" },
        { type: "wind", label: "풍속", color: "#1a659e" },
      ],

      headers: [
        { value: "date", text: "측정일" },
        // { value: "checkTime", text: "측정시간" },
        { value: "watt_sum", text: "전력량"},
        { value: "w_temp", text: "온도" },
        { value: "w_hum", text: "습도"},
        { value: "w_ps", text: "기압"},
        { value: "w_ws", text: "풍속" },
      ],
      dailyheaders: [
        { type: 'watt', label: '전력량' },
        { type: "w_temp", label: "온도" },
        { type: "w_hum", label: "습도"},
        { type: "w_ps", label: "기압"},
        { type: "w_ws", label: "풍속" },
      ],

      kepco:[],
      listDataKepcoNo: {},
      // listDataKepcoNo:{},
      trendData: {},
    }
  },
  async created() {
    Apis.getIpClient((res) => {
      // console.log(res);  
      let client = res
      Apis.pageCount({ //페이지뷰 카운터
        page_name: `${client.city}/${client.country}/${client.region}/${client.loc}/${client.org}/${client.postal}/${client.timezone}`,
        url: this.$route.path,
        ip: client.ip,
        division: "cloud",
      },() => {  // 정상처리
        // console.log("pageCount 호출",res);
      }).catch( (err) => {  // 개별 API 오류 처리 예제
        console.log("pageCount 호출 오류",err);
      });
    }).catch( (err) => {  // API 오류 처리
        console.log("getIpClient 호출 오류",err)
    }) 
    this.setDefaultDates();
  },
  methods:{
    async farmInfo(data){
      // console.log(data)
      this.farmData = data;
      await this.kepcoNo();

      this.refreshData();
    },
    updateFrDate(date) {
      this.fr_date = date;
    },
    updateToDate(date) {
      this.to_date = date;
    },
    setDefaultDates() {
      const cdate = new Date();
      this.to_date = dateUtil.format(cdate, "yyyy-MM-dd");

      const frdate = new Date();
      if (this.term === 0) {
        this.fr_date = this.to_date;
      } else {
        frdate.setDate(cdate.getDate() - 6)
        this.fr_date = dateUtil.format(frdate, "yyyy-MM-dd")
      }
    },
    refreshData(){
      if(!this.farmData.farm.kepco){
        alert('등록된 한전번호가 없습니다.')
      }else{
        this.wattData();
      }
      
    },
    async kepcoNo(){
      this.kepco = [];

      Apis.listTimelyKepcoDataEach({ 
        company_cd: this.farmData.company_cd,
        farm_cd:  this.farmData.farm.code,
        fr_dt: this.fr_date,
        to_dt: this.to_date,
        start_time: "00:00:00",
        end_time: "23:59:59",
        timeDivision: this.term === 0 ? 15 : 60,
        },(res) => {  
          // console.log(res.data)
          this.kepco = res.data;

          this.loading = false;
        }).catch( (err) => {  // API 오류 처리
          console.log("listTimelyKepcoData API 호출 오류",err)
          alert(err);
          this.loading = false;
        })
    },
    wattData(){
      this.$store.commit("resMessage","");
      this.loading = true;

      if (this.term < 2) {   // 시간별
        Apis.listTimelyKepcoDataEach({ 
          company_cd: this.farmData.company_cd,
          farm_cd:  this.farmData.farm.code,
          fr_dt: this.fr_date,
          to_dt: this.to_date,
          start_time: "00:00:00",
          end_time: "23:59:59",
          timeDivision: this.term === 0 ? 15 : 60,
          },(res) => {  
            this.listDataKepcoNo = {}; 
            this.trendData = {};

            res.data.forEach(kepcoData => {
              const kepcoNo = kepcoData.kepco_no;
              const dataList = kepcoData.datalist;

              this.listDataKepcoNo[kepcoNo] = dataList.map(element => ({
                date: element.checkDateTime.substring(5, 16),
                // time: element.checkTime.substring(0,5),
                watt_sum: element.watt_sum ? Number(element.watt_sum).toFixed(2) : null,
                w_temp: element.w_temp ? Number(element.w_temp).toFixed(1) : null,
                w_hum: element.w_hum ? Number(element.w_hum).toFixed(0) : null,
                w_ps: element.w_ps ? Number(element.w_ps).toFixed(0) : null,
                w_ws: element.w_ws ? Number(element.w_ws).toFixed(1) : null,
              }));


              const time_watt = [];
              const watt_array = [];

              const time_temp = [];
              const temp_array = [];

              const time_hum = [];
              const hum_array = [];

              const time_pres = [];
              const pres_array = [];

              const time_wind = [];
              const wind_array = [];

              dataList.forEach(element => {
                // 값 변환
                if (element.watt_sum) element.watt_sum = Number(element.watt_sum).toFixed(2);
                if (element.w_hum) element.w_hum = Number(element.w_hum).toFixed(0);
                if (element.w_ps) element.w_ps = Number(element.w_ps).toFixed(0);
                if (element.w_ws) element.w_ws = Number(element.w_ws).toFixed(1);
                if (element.w_temp) element.w_temp = Number(element.w_temp).toFixed(1);

                // chart data 구성
                // if (element.watt_sum && !isNaN(element.watt_sum)) {
                  time_watt.push(element.checkDateTime.substring(5, 16));
                  watt_array.push(Number(element.watt_sum));

                  time_temp.push(element.checkDateTime.substring(5, 16));
                  temp_array.push(element.w_temp ? Number(element.w_temp) : null);

                  time_hum.push(element.checkDateTime.substring(5, 16));
                  hum_array.push(element.w_hum ? Number(element.w_hum) : null);

                  time_pres.push(element.checkDateTime.substring(5, 16));
                  pres_array.push(element.w_ps ? Number(element.w_ps) : null);

                  time_wind.push(element.checkDateTime.substring(5, 16));
                  wind_array.push(element.w_ws ? Number(element.w_ws) : null);
                // }
              });

              // kepco_no 별로 trendData를 저장
              this.trendData[kepcoNo] = {
                term: this.term,
                time_watt: time_watt,
                watt: watt_array,
                time_temp : time_temp,
                temp: temp_array,
                time_hum : time_hum,
                hum: hum_array,
                time_pres : time_pres,
                pres: pres_array,
                time_wind : time_wind,
                wind: wind_array,
              };
            })

            
            this.loading=false;
          }).catch( (err) => {  // API 오류 처리
            console.log("listTimelyKepcoData API 호출 오류",err)
            alert(err);
            this.loading = false;
          })
        }else if(this.term == 2){
          Apis.kepcoDataDailyViewEach({ 
            farm_cd : this.farmData.farm.code,
            fr_date : this.fr_date,
            to_date : this.to_date
          },(res) => {  
            this.trendData = {};
            this.listDataKepcoNo = {}; 

            res.data.forEach(kepcoData => {
              const kepcoNo = kepcoData.kepco_no;
              const dataList = kepcoData.daily;


              this.listDataKepcoNo[kepcoNo] = dataList.reverse().map(element => ({
                  checkDate: element.checkDate,

                  watt_average: element.watt_sum ? Number(element.watt_sum).toFixed(2) : null,
                  watt_highest: element.watt_sum ? Number(element.watt_highest).toFixed(2) : null,
                  watt_lowest: element.watt_sum ? Number(element.watt_lowest).toFixed(2) : null,
                  
                  w_temp_average: element.w_temp_average ? Number(element.w_temp_average).toFixed(1) : null,
                  w_temp_highest: element.w_temp_highest ? Number(element.w_temp_highest).toFixed(1) : null,
                  w_temp_lowest: element.w_temp_lowest ? Number(element.w_temp_lowest).toFixed(1) : null,
                  
                  w_hum_average: element.w_hum_average ? Number(element.w_hum_average).toFixed(0) : null,
                  w_hum_highest: element.w_hum_highest ? Number(element.w_hum_highest).toFixed(0) : null,
                  w_hum_lowest: element.w_hum_lowest ? Number(element.w_hum_lowest).toFixed(0) : null,
                  
                  w_ps_average: element.w_ps_average ? Number(element.w_ps_average).toFixed(0) : null,
                  w_ps_highest: element.w_ps_highest ? Number(element.w_ps_highest).toFixed(0) : null,
                  w_ps_lowest: element.w_ps_lowest ? Number(element.w_ps_lowest).toFixed(0) : null,
                  
                  w_ws_average: element.w_ws_average ? Number(element.w_ws_average).toFixed(1) : null,
                  w_ws_highest: element.w_ws_highest ? Number(element.w_ws_highest).toFixed(1) : null,
                  w_ws_lowest: element.w_ws_lowest ? Number(element.w_ws_lowest).toFixed(1) : null,
              }));

              // console.log(this.listDataKepcoNo)

              const checkDate = [];
              
              const watt_sum = [];
              const watt_low = [];
              const watt_high = [];

              const temp_avg = [];
              const temp_low = [];
              const temp_high = [];

              const hum_avg = [];
              const hum_low = [];
              const hum_high = [];

              const pres_avg = [];
              const pres_low = [];
              const pres_high = [];

              const wind_avg = [];
              const wind_low = [];
              const wind_high = [];

              dataList.forEach(element => {
                // chart data 구성
                // if (element.watt_sum && !isNaN(element.watt_sum)) {

                  checkDate.push(element.checkDate.substring(5));

                  watt_sum.push(element.watt_sum  ? Number(element.watt_sum) : null);
                  watt_low.push(element.watt_lowest ? Number(element.watt_lowest) : null);
                  watt_high.push(element.watt_highest ? Number(element.watt_highest) : null);

                  temp_avg.push(element.w_temp_average ? Number(element.w_temp_average) : null);
                  temp_low.push(element.w_temp_lowest ? Number(element.w_temp_lowest) : null);
                  temp_high.push(element.w_temp_highest ? Number(element.w_temp_highest) : null);

                  hum_avg.push(element.w_hum_average ? Number(element.w_hum_average) : null);
                  hum_low.push(element.w_hum_lowest ? Number(element.w_hum_lowest) : null);
                  hum_high.push(element.w_hum_highest ? Number(element.w_hum_highest) : null);

                  pres_avg.push(element.w_ps_average ? Number(element.w_ps_average) : null);
                  pres_low.push(element.w_ps_lowest ? Number(element.w_ps_lowest) : null);
                  pres_high.push(element.w_ps_highest ? Number(element.w_ps_highest) : null);

                  wind_avg.push(element.w_ws_average ? Number(element.w_ws_average) : null);
                  wind_low.push(element.w_ws_lowest ? Number(element.w_ws_lowest) : null);
                  wind_high.push(element.w_ws_highest ? Number(element.w_ws_highest) : null);

                // }
              });

              // kepco_no 별로 trendData를 저장
              this.trendData[kepcoNo] = {
                checkDate: checkDate,

                watt_sum: watt_sum,
                watt_low: watt_low,
                watt_high: watt_high,

                temp_avg: temp_avg,
                temp_low: temp_low,
                temp_high: temp_high,

                hum_avg: hum_avg,
                hum_low: hum_low,
                hum_high: hum_high,

                pres_avg: pres_avg,
                pres_low: pres_low,
                pres_high: pres_high,

                wind_avg: wind_avg,
                wind_low: wind_low,
                wind_high: wind_high,
              };

              // console.log(this.trendData)
            })

            
            this.loading=false;
          }).catch( (err) => {  // API 오류 처리
            console.log("kepcoDataDailyViewEach API 호출 오류",err)
            alert(err);
            this.loading = false;
          })
        }else{
          Apis.kepcoDataMonthlyViewEach({ 
            farm_cd : this.farmData.farm.code,
            fr_date : this.fr_date,
            to_date : this.to_date,
            term : this.term,
            number_row : 13
          },(res) => {  
            this.trendData = {};
            this.listDataKepcoNo = {}; 

            res.data.forEach(kepcoData => {
              const kepcoNo = kepcoData.kepco_no;
              const dataList = kepcoData.daily;
              
              this.listDataKepcoNo[kepcoNo] = dataList.reverse().map(element => ({
                  checkDate: element.checkDate,

                  watt_average: element.watt_sum ? Number(element.watt_sum).toFixed(0) : null,
                  watt_highest: element.watt_highest ? Number(element.watt_highest).toFixed(0) : null,
                  watt_lowest: element.watt_lowest ? Number(element.watt_lowest).toFixed(0) : null,
                  
                  w_temp_average: element.w_temp_average ? Number(element.w_temp_average).toFixed(1) : null,
                  w_temp_highest: element.w_temp_highest ? Number(element.w_temp_highest).toFixed(1) : null,
                  w_temp_lowest: element.w_temp_lowest ? Number(element.w_temp_lowest).toFixed(1) : null,
                  
                  w_hum_average: element.w_hum_average ? Number(element.w_hum_average).toFixed(0) : null,
                  w_hum_highest: element.w_hum_highest ? Number(element.w_hum_highest).toFixed(0) : null,
                  w_hum_lowest: element.w_hum_lowest ? Number(element.w_hum_lowest).toFixed(0) : null,
                  
                  w_ps_average: element.w_ps_average ? Number(element.w_ps_average).toFixed(0) : null,
                  w_ps_highest: element.w_ps_highest ? Number(element.w_ps_highest).toFixed(0) : null,
                  w_ps_lowest: element.w_ps_lowest ? Number(element.w_ps_lowest).toFixed(0) : null,
                  
                  w_ws_average: element.w_ws_average ? Number(element.w_ws_average).toFixed(1) : null,
                  w_ws_highest: element.w_ws_highest ? Number(element.w_ws_highest).toFixed(1) : null,
                  w_ws_lowest: element.w_ws_lowest ? Number(element.w_ws_lowest).toFixed(1) : null,
              }));
              
              const checkDate = [];
              
              const watt_sum = [];
              const watt_low = [];
              const watt_high = [];

              const temp_avg = [];
              const temp_low = [];
              const temp_high = [];

              const hum_avg = [];
              const hum_low = [];
              const hum_high = [];

              const pres_avg = [];
              const pres_low = [];
              const pres_high = [];

              const wind_avg = [];
              const wind_low = [];
              const wind_high = [];

              dataList.forEach(element => {
                // chart data 구성
                if (element.watt_sum && !isNaN(element.watt_sum)) {

                  checkDate.push(element.checkDate);

                  watt_sum.push(element.watt_sum ? Number(element.watt_sum) : null);
                  watt_low.push(element.watt_lowest ? Number(element.watt_lowest) : null);
                  watt_high.push(element.watt_highest ? Number(element.watt_highest) : null);

                  temp_avg.push(element.w_temp_average ? Number(element.w_temp_average) : null);
                  temp_low.push(element.w_temp_lowest ? Number(element.w_temp_lowest) : null);
                  temp_high.push(element.w_temp_highest ? Number(element.w_temp_highest) : null);

                  hum_avg.push(element.w_hum_average ? Number(element.w_hum_average) : null);
                  hum_low.push(element.w_hum_lowest ? Number(element.w_hum_lowest) : null);
                  hum_high.push(element.w_hum_highest ? Number(element.w_hum_highest) : null);

                  pres_avg.push(element.w_ps_average ? Number(element.w_ps_average) : null);
                  pres_low.push(element.w_ps_lowest ? Number(element.w_ps_lowest) : null);
                  pres_high.push(element.w_ps_highest ? Number(element.w_ps_highest) : null);

                  wind_avg.push(element.w_ws_average ? Number(element.w_ws_average) : null);
                  wind_low.push(element.w_ws_lowest ? Number(element.w_ws_lowest) : null);
                  wind_high.push(element.w_ws_highest ? Number(element.w_ws_highest) : null);

                }
              });

              // kepco_no 별로 trendData를 저장
              this.trendData[kepcoNo] = {
                checkDate: checkDate,

                watt_sum: watt_sum,
                watt_low: watt_low,
                watt_high: watt_high,

                temp_avg: temp_avg,
                temp_low: temp_low,
                temp_high: temp_high,

                hum_avg: hum_avg,
                hum_low: hum_low,
                hum_high: hum_high,

                pres_avg: pres_avg,
                pres_low: pres_low,
                pres_high: pres_high,

                wind_avg: wind_avg,
                wind_low: wind_low,
                wind_high: wind_high,
              };

              // console.log(  this.trendData)
            })

            
            this.loading=false;
          }).catch( (err) => {  // API 오류 처리
            console.log("kepcoDataMonthlyViewEach API 호출 오류",err)
            alert(err);
            this.loading = false;
          })
        }
      },
      getChartData(dataKey, kepcoNo) {
        const { type, color } = dataKey;
        const trendDataForKepco = this.trendData[kepcoNo] || {};

        return {
          labels: trendDataForKepco.checkDate || [],
          datasets: [
            {
              type: "bar",
              label: '전력량', 
              data: trendDataForKepco.watt_sum,
              backgroundColor: "#FFF1CA",
              fill: false,
              yAxisID: "y2",
              barPercentage: 0.5,
              borderRadius: 10,
              order: 2,
            },
            {
              type: "line",
              label: `${dataKey.label} 평균`,
              data: trendDataForKepco[`${type}_avg`] || [],
              borderColor: color,
              fill: false,
              yAxisID: "y1",
            },
            {
              type: "line",
              label: `${dataKey.label} 최고`,
              data: trendDataForKepco[`${type}_high`] || [],
              borderColor: "rgba(239, 68, 68, 0.5)",
              borderDash: [5, 5],
              fill: false,
              yAxisID: "y1",
            },
            {
              type: "line",
              label: `${dataKey.label} 최저`,
              data: trendDataForKepco[`${type}_low`] || [],
              borderColor: "rgba(29, 78, 216, 0.5)",
              borderDash: [5, 5],
              fill: false,
              yAxisID: "y1",
            },
          ],
        };
      },
      getTrendDataForKepco(kepcoNo) {
        return this.trendData[kepcoNo] || {};
      },
      getListDataForKepco(kepcoNo) {
        return this.listDataKepcoNo[kepcoNo] || [];
      },
    
  }

}
</script>

<style scoped lang="scss">
@import '../../style/base.scss';
.value_container{
  display:flex;
  margin-top:10px;
  width:80%;
  // justify-content: space-between;
}
.timebar{
  min-width:350px;
  margin-right:5px;
}
.v-tabs-items{
  padding:10px !important;
  background-color: #F3F3F3 !important;
}
.cost-tabs{
  width:50%;
}
.cost-tab{
  width:100%;
  min-width:145px;
  max-width:145px;
}
.kepco-text{
  letter-spacing: -0.75px;
  font-size:1.0rem;
  font-weight:600;
}
.info-text{
  font-size:0.7rem;
  color:#9c9c9c;
}
.watt-conatiner{
  margin-top:5px;
}
.label{
  background-color: #E7EDFD;
  font-weight:500;
  letter-spacing: -1px;
  padding:5px;
  border-radius: 5px;
}
@media screen and (max-width: 768px) {
  .combo_box{
    flex-direction: column;
  }
  .select_building{
    width:150px !important;
  }
  .select_room{
    width:180px !important;
  }
  .select_room{
    margin-top:10px;
  }
  .mb-combo{
    display: flex;
    margin-top:10px;
  }
  .timebar{
    min-width:250px !important;
    height:40px;
  }
  .value_container{
    flex-direction: column;
    justify-content: center !important;
    // width:480px;
    width:100% !important;
    // min-width:480px !important;
  }
  .mb-col{
    flex-direction: column;
  }
  .search, .report__btn{
    display: none;
  }
}
</style>